import { memo } from "react";

const { TableRow, TableCell } = require("@material-ui/core");

const GroupTotalRow = ({ total, columns }) => {
  const formattedTotal = (value) =>
    `${value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    })}`;

  return (
    <TableRow>
      {columns.map((column, index) => {
        if (index === 0) {
          return (
            <TableCell size="small" style={{ backgroundColor: "#d6e5ff" }}>
              Total
            </TableCell>
          );
        }
        return (
          <TableCell
            size="small"
            align="right"
            style={{ backgroundColor: column.cellColor ?? "#d6e5ff" }}
          >
            {!total[column.id] ? "" : formattedTotal(total[column.id])}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default memo(GroupTotalRow);
